import PropTypes from 'prop-types';

import { translations } from 'hb-react/shared/apps/Memberships/utils/translations';

import AmericanExpress from './AmericanExpress';
import ApplePay from './ApplePay';
import Bancontact from './Bancontact';
import GooglePay from './GooglePay';
import Ideal from './Ideal';
import Maestro from './Maestro';
import Mastercard from './Mastercard';
import PayPal from './PayPal';
import Sepa from './Sepa';
import Visa from './Visa';

const providers = {
  americanexpress: AmericanExpress,
  amex: AmericanExpress,
  'american express': AmericanExpress,
  applepay: ApplePay,
  bancontact: Bancontact,
  googlepay: GooglePay,
  ideal: Ideal,
  mastercard: Mastercard,
  maestro: Maestro,
  paypal: PayPal,
  sepa: Sepa,
  visa: Visa,
};

const PaymentProviderIcon = ({ provider = '', ...props }) => {
  const Icon = providers[provider?.toLowerCase()];

  if (!Icon) {
    return provider ? translations.paymentMethods[provider] ?? provider : '-';
  }

  return <Icon width="60px" height="44px" {...props} />;
};

PaymentProviderIcon.propTypes = {
  provider: PropTypes.string,
};

export default PaymentProviderIcon;
